export default __webpack_public_path__ + "static/media/coach_ok.b7cd2658.png";